import { render } from "./ContactPhoto.vue?vue&type=template&id=185fb0c8"
import script from "./ContactPhoto.vue?vue&type=script&lang=js"
export * from "./ContactPhoto.vue?vue&type=script&lang=js"

import "./ContactPhoto.vue?vue&type=style&index=0&id=185fb0c8&lang=less"

import exportComponent from "../../../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__